import { CSSProperties } from 'react';
import { innerFormContainerStyle, rightHeaderContainerStyle, submitBtnStyle } from '@vivli/shared/components';
import { useAdminStudyPermissions, useAdminStudyStatusChange } from '@vivli/features/studies/infrastructure/hook';
import { useStudyContext } from '@vivli/features/studies/infrastructure/context';
import { Size } from '@vivli/shared/theme';
import { StudyApproveRejectButtonView } from '../study-approve-reject-button.component';
import { useFormState } from 'react-hook-form';
import { DTICommonConst } from '@vivli/shared/infrastructure/constants';
import { AdminHeaderButtonView } from '@vivli/shared/views';

const actionButtonStyle: CSSProperties = {
    ...submitBtnStyle,
    backgroundImage: 'none',
    paddingLeft: Size.PADDING,
    paddingRight: Size.PADDING,
    marginRight: Size.PADDING
};

export const AdminStudyHeaderContainerComponent = () => {
    const {
        study,
        studyIpdPackageSubmitted,
        isSavingStudy,
        handleFormSave,
        handleSetupForNewIpdVersion,
        handleCreateDoiForIpdPackage,
        handleDeleteIpdPackage,
        handleApproveStudy,
        handleRejectStudy,
        handleRemovePosting,
        handleMaintainDois
    } = useStudyContext();
    const { isValid, isDirty } = useFormState();
    const adminStudyRules = useAdminStudyStatusChange(study);
    const permissions = useAdminStudyPermissions(study, studyIpdPackageSubmitted);
    const approval = adminStudyRules.getApprovalMessage();
    const rejection = adminStudyRules.getRejectionMessage();

    return (
        <div style={innerFormContainerStyle}>
            <div style={rightHeaderContainerStyle}>
                {permissions.userIsVivliAdmin() && (
                    <AdminHeaderButtonView
                        title={'Create DOI'}
                        onClick={() => handleMaintainDois()}
                        isLoading={isSavingStudy}
                        style={actionButtonStyle}
                        dataId={DTICommonConst.CreateDOIButton}
                    />
                )}
                {permissions.userIsVivliAdmin() && studyIpdPackageSubmitted && (
                    <AdminHeaderButtonView
                        title={'Remove Stored Data Package'}
                        onClick={() => handleDeleteIpdPackage()}
                        isLoading={isSavingStudy}
                        style={actionButtonStyle}
                        dataId={DTICommonConst.RemoveButton}
                    />
                )}
                {studyIpdPackageSubmitted && (
                    <AdminHeaderButtonView
                        title={'Prepare For New Data Version'}
                        onClick={() => handleSetupForNewIpdVersion()}
                        isLoading={isSavingStudy}
                        style={actionButtonStyle}
                        dataId={DTICommonConst.HeaderApprovalButton('PrepareNewData')}
                    />
                )}
                {permissions.userCanRemovePosting() && (
                    <AdminHeaderButtonView
                        title={'Remove Posting'}
                        onClick={() => handleRemovePosting()}
                        isLoading={isSavingStudy}
                        isDisabled={false}
                        style={actionButtonStyle}
                        dataId={DTICommonConst.CancelButton}
                    />
                )}
                {
                    <StudyApproveRejectButtonView
                        onRejectStudyClick={() => handleRejectStudy()}
                        onApproveStudyClick={() => handleApproveStudy()}
                        approveLabel={approval}
                        rejectLabel={rejection}
                        showApprove={approval !== null}
                        showReject={rejection !== null}
                        isLoading={isSavingStudy}
                        isDisabled={isDirty || !isValid} //approve only uses this
                    />
                }
                {permissions.userCanSave() && (
                    <AdminHeaderButtonView
                        title={'Save'}
                        onClick={() => handleFormSave()}
                        isLoading={isSavingStudy}
                        isDisabled={!isDirty || !isValid}
                        style={actionButtonStyle}
                        dataId={DTICommonConst.SaveButton}
                    />
                )}
            </div>
        </div>
    );
};
